"use strict";
/**
 * @file Created on 04.06.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Tomas Leity
 */


var NotificationDocConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(NotificationDocConverter, _DataObjectConverter_);

  function NotificationDocConverter() {
    _classCallCheck(this, NotificationDocConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(NotificationDocConverter).apply(this, arguments));
  }

  return NotificationDocConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.NotificationDocConverter = NotificationDocConverter;